import env from 'env'

const { BASE_URL } = env

// dashboard v2
export const DASHBOARD_V2_BASE = `${BASE_URL}/dashboard/v2`
export const PROPERTY = `${DASHBOARD_V2_BASE}/properties`
export const SINGLE_PROPERTY = `${PROPERTY}/:propertyId`
export const LISTING_MANAGE = `${SINGLE_PROPERTY}/listing/manage`

// public page
export const LISTING_PUBLIC = `${BASE_URL}/listing/:slug`
export const AGENT_PROFILE_PUBLIC = `${BASE_URL}/profile/:slug`
